export default __webpack_public_path__ + "static/media/exclametry_bg_gray.a7dbc5d8.svg";